<script lang="ts">
    import { getMessage } from "@app/services/i18n.service";
    import type { I18NMessage } from "@app/services/i18n.messages";
    export let fieldNameMessage: I18NMessage;
    export let fieldDescriptionPlaceholderMessage: I18NMessage;
    export let fieldHintMessage: I18NMessage | undefined = undefined;
    import { dictionary } from "@app/services/currentDictionary.service";
    let placeholderL1 = `${getMessage(fieldDescriptionPlaceholderMessage)} (${
        $dictionary.l1.name
    })`;
    let placeholderL2 = `${getMessage(fieldDescriptionPlaceholderMessage)} (${
        $dictionary.l2.name
    })`;
</script>

<div class="odd:bg-slate-50">
    <div class="py-3 flex">
        <h4 class="text-sm font-medium text-gray-900 px-1 w-1/5 flex items-center">
            {getMessage(fieldNameMessage)}
        </h4>
        <div class="flex-1">
            <div class="flex">
                <div class="w-1/2 px-2">
                    <slot name="l1" {placeholderL1} {placeholderL2} />
                </div>
                <div class="w-1/2 px-2">
                    <slot name="l2" {placeholderL1} {placeholderL2} />
                </div>
            </div>
            <slot {placeholderL1} {placeholderL2} />

            {#if $$slots.hint || fieldHintMessage}
                <p class="px-2 text-xs text-gray-600 pt-1">
                    {#if fieldHintMessage}
                        {getMessage(fieldHintMessage)}
                    {:else}
                        <slot name="hint" />
                    {/if}
                </p>
            {/if}
        </div>
    </div>
    <div class="mx-1 border-b border-gray-300 border-dashed" />
</div>
